import styled from "styled-components";

export const StyledAnimatedButton = styled.div`
  border-radius: 4px;
  border: 2px solid transparent;
  color: inherit;
  display: flex;
  padding: 14px 0px 14px 0px;
  min-height: 64px;
  justify-content: center;

  &:hover {
    background: ${({ theme }) => theme.card["transparent"].hover.background};
    color: inherit !important;
    text-decoration: none !important;
  }

  &:focus-visible {
    border: ${({ theme }) => `2px solid ${theme.brand}`};
    color: inherit !important;
    text-decoration: none !important;
    outline: none;
  }
`;

export const StyledSeparator = styled.hr`
  border-bottom-width: 0px;
`;
